import styled from 'styled-components';

export const ContactContainer = styled.div`
  .container {
    position: relative;
    z-index: 9;
  }

  .contact-hero-main {
    position: relative;
  }

  .contact-hero h1 {
    font-size: 85px;
    letter-spacing: -0.63px;
    line-height: 79px;
  }
  .inner-hero-area.contact-hero {
    padding: 130px 0 0;
  }

  .hs-form-field {
    margin-bottom: 35px;
  }

  .hs-error-msgs {
    list-style: none;
    color: ${({ theme: { colors } }) => colors.pink};
    font-weight: bold;

    li {
      margin-top: 10px;
    }
  }

  .contact-input,
  .hs-input {
    width: 100%;
    height: 55px;
    background-color: transparent;
    border: none;
    border-radius: 0 !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.4);
    color: #000000;
    font-size: 20px;
    letter-spacing: -0.15px;
    line-height: 33px;
    padding: 10px 5px 10px 0;
    font-family: 'Be Vietnam Pro';
    font-weight: 600;
    box-shadow: unset !important;

    &:focus {
      border-bottom: 1px solid ${({ theme: { colors } }) => colors.pink};
    }
  }

  textarea.contact-input {
    resize: vertical;
  }

  .contact-form label,
  .hs-form-field label:not(.hs-error-msg) {
    color: #000000;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.15px;
    line-height: 33px;
    font-family: 'Be Vietnam Pro';
  }

  .hs-field-desc {
    margin-top: 10px;
  }

  .contact-form-main::before {
    background-color: #fff;
    position: absolute;
    top: 0;
    width: 59%;
    height: 100%;
    content: '';

    @media only screen and (max-width: 767px) {
      width: 100%;
    }
  }
  .contact-form-main {
    position: relative;
    padding: 115px 0 200px;
  }

  .term-label.contact-term {
    font-size: 13px;
    letter-spacing: -0.1px;
    line-height: 19px;
    font-weight: 400;
    font-family: 'Be Vietnam Pro';
    padding-left: 35px;
  }
  .contact-term::before {
    position: absolute;
    width: 19px;
    height: 19px;
    border: 1px solid #ff4552;
    border-radius: 3px;
    background-color: transparent;
    transition: 0.3s all;
    top: 0;
  }
  .contact-term::after {
    position: absolute;
    left: 0;
    width: 19px;
    height: 19px;
    border-radius: 0;
    background-color: transparent;
    content: '';
    font-family: 'Font Awesome 5 Pro';
    font-weight: 200;
    background-color: transparent;
    transition: 0.3s all;
    top: 0;
    bottom: 0;
    right: 0;
    text-align: center;
    color: #fff;
  }
  #term-checkbox:checked + .term-label::before {
    background-color: #ff4552;
  }

  .contact-form .small-label {
    font-size: 13px;
    letter-spacing: -0.1px;
    line-height: 19px;
    font-family: 'Be Vietnam Pro';
    font-weight: 400;
  }
  .single-address {
    h4 {
      color: #ffffff;
      font-size: 30px;
      font-weight: bold;
      line-height: 43px;
      margin-bottom: 0;
    }

    p {
      color: #ffffff;
      font-size: 18px;
      letter-spacing: 0.2px;
      line-height: 28px;
      margin: 0;
    }

    a {
      color: #ffffff;
      font-size: 18px;
      letter-spacing: 0.2px;
      line-height: 28px;
      margin: 0;

      &:hover {
        color: ${({ theme: { colors } }) => colors.pink};
      }

      @media only screen and (max-width: 767px) {
        color: initial;
      }
    }
  }
  .single-address {
    padding-bottom: 40px;
  }

  .contact-bg {
    position: absolute;
    right: 0;
    width: 25%;
    opacity: 0.62;
    top: 0;
    z-index: 0;
  }

  .contact-form-main::after {
    position: absolute;
    top: -100px;
    right: 0;
    content: '';
    width: 50%;
    height: 80%;
    z-index: 0;
    left: 15%;
    opacity: 0.03;
    background-color: #fafafa;
  }

  .our-office-main {
    background-color: #ff4552;
    padding-top: 100px;
  }
  .offices-single {
    position: relative;
    margin-top: 65px;
    min-height: 372px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .offices-overlay {
    padding: 105px 30px;
    position: absolute;
    top: -10%;
    width: 100%;
    height: 110%;
    background-color: #0a090b;
    left: 0;
    opacity: 0;
    visibility: hidden;
    transition: 0.3s all ease-in-out;
  }
  .offices-single:hover .offices-overlay {
    opacity: 1;
    visibility: visible;
  }
  .offices-overlay h4 {
    color: #ffffff;
    font-size: 30px;
    font-weight: bold;
    line-height: 43px;
  }
  .offices-overlay p {
    color: #ffffff;
    font-size: 18px;
    letter-spacing: 0.2px;
    line-height: 28px;
  }

  button[type='submit'] {
    &:disabled {
      opacity: 0.54;
      cursor: not-allowed;

      &::after {
        content: unset;
      }
    }
  }

  .success-message {
    background-color: rgba(0, 0, 0, 0.05);
    padding: 10px 15px;

    p {
      margin: 0;

      i {
        margin-right: 10px;
      }
    }
  }

  @media (max-width: 1024px) {
    .contact-bg {
      width: 40%;
    }

    .offices-single {
      min-height: 402px;
    }
    .offices-overlay {
      opacity: 1;
      visibility: visible;
      min-height: 200px;
      position: absolute;
      top: auto;
      padding: 20px;
      bottom: 0;
      height: auto;
    }
    .offices-overlay h4 {
      font-size: 22px;
      line-height: 32px;
    }
  }

  @media (max-width: 767px) {
    .contact-bg {
      top: -100px;
      right: unset;
      left: 0;
      opacity: 0.3;
    }
    .contact-hero h1 {
      font-size: 48px;
      line-height: 51px;
    }

    .contact-form {
      position: relative;
      z-index: 1;
      background-color: #fafafa;
      padding: 25px;
      margin-bottom: 35px;
    }

    .contact-form-main {
      padding: 15px 0 0;
    }

    .contact-form label {
      font-size: 16px;
      line-height: 28px;
    }
    .contact-input {
      height: 35px;
      padding: 5px 5px;
    }

    .contact-address-block {
      background-color: #fff;
      margin: 0px -15px 0;
      padding: 100px 20px 30px;
      z-index: 0;
    }

    .single-address h4,
    .single-address p {
      color: #0a090b;
    }
    .single-address {
      padding-bottom: 30px;
    }
    .offices-single {
      margin-top: 0;
      margin-bottom: 25px;
    }

    .offices-overlay {
      min-height: 10px;
    }
    .offices-single {
      min-height: 312px;
    }
  }
`;
